import { SHOW_ERROR, HIDE_ERROR } from "../actions/errorActions"

const initialState = {
    error: {
        show: false,
        title: "no title",
        message: "no message"
    }
}

const errorReducer =(state = initialState, action:any) => {
    const newState = { ...state };
    switch (action.type) {
        case SHOW_ERROR: {
            newState.error = action.payload
            return newState
        }
        case HIDE_ERROR: {
            newState.error = action.payload
            return newState
        }
        default:
            return newState
    }
}
export default errorReducer;